var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [
        _c(
          "div",
          {
            staticClass:
              "w-100pct h-60px bg-cl-black cl-white f-s-18px f-w-bold pd-18px"
          },
          [
            _c(
              "router-link",
              { attrs: { to: { name: "Payment" } } },
              [
                _c("svg-filler", {
                  staticClass: "mg-r-auto f-left cs-pointer",
                  attrs: {
                    path: "/static/svg/back.svg",
                    fill: "#ffffff",
                    width: "20px",
                    height: "20px"
                  },
                  on: {
                    click: function($event) {
                      _vm.clear()
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("span", [_vm._v("\n        ชำระเงินด้วยเงินสด\n      ")])
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "w-100pct h-60calc" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "mg-t-23px f-s-16px f-w-bold" }, [
            _c("span", [
              _vm._v(
                "ยอดที่ต้องชำระ ฿ " +
                  _vm._s(_vm._f("showFullPriceFormat")(_vm.netPrice))
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mg-t-16px f-s-14px" }, [
            _vm._v("\n        ใส่จำนวนเงินที่ได้รับ\n      ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mg-t-8px f-s-14px w-300px mg-auto" }, [
            _c(
              "div",
              {
                staticClass: "price-btn pd-8px cs-pointer mg-l-7px f-left",
                on: {
                  click: function($event) {
                    _vm.addReceive(1000)
                  }
                }
              },
              [_vm._v("\n          1,000\n        ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "price-btn pd-8px cs-pointer mg-l-7px f-left",
                on: {
                  click: function($event) {
                    _vm.addReceive(2000)
                  }
                }
              },
              [_vm._v("\n          2,000\n        ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "price-btn pd-8px cs-pointer mg-l-7px f-left",
                on: {
                  click: function($event) {
                    _vm.addReceive(3000)
                  }
                }
              },
              [_vm._v("\n          3,000\n        ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "price-btn pd-8px cs-pointer mg-l-7px f-left",
                on: {
                  click: function($event) {
                    _vm.addReceive(5000)
                  }
                }
              },
              [_vm._v("\n          5,000\n        ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "price-btn pd-8px cs-pointer mg-l-7px f-left",
                on: {
                  click: function($event) {
                    _vm.clear()
                  }
                }
              },
              [_vm._v("\n          Clear\n        ")]
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "pd-t-8px f-s-14px w-190px mg-auto" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.receive,
                  expression: "receive"
                }
              ],
              staticClass: "price-inp pd-6px f-left",
              attrs: { type: "number", placeholder: "0,000", min: "0" },
              domProps: { value: _vm.receive },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.receive = $event.target.value
                  },
                  function($event) {
                    _vm.calculatedChange({
                      receive: _vm.receive,
                      netPrice: _vm.netPrice
                    })
                  }
                ]
              }
            })
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "mg-t-10px f-s-16px f-w-bold" }, [
            _vm._v("\n        จำนวนเงินทอน "),
            _c("br"),
            _vm._v(
              "\n        ฿ " +
                _vm._s(_vm._f("showFullPriceFormat")(_vm.change)) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mg-t-13px f-s-16px f-w-bold" }, [
            _vm.receivedCash < _vm.netPrice || _vm.fullPrice === 0
              ? _c(
                  "div",
                  { staticClass: "checkout-btn cs-not-allowed mg-auto pd-8px" },
                  [_vm._v(" ชำระเงินเสร็จสิ้น ")]
                )
              : _c(
                  "div",
                  {
                    staticClass: "checkout-btn cs-pointer mg-auto pd-8px",
                    on: {
                      click: function($event) {
                        _vm.finishCheckout("Cash")
                      }
                    }
                  },
                  [_vm._v(" ชำระเงินเสร็จสิ้น ")]
                )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { active: _vm.activeModal, canCancel: [] },
          on: {
            "update:active": function($event) {
              _vm.activeModal = $event
            }
          }
        },
        [_c("SelectPrinter")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pd-t-13px" }, [
      _c("img", {
        staticClass: "w-78px",
        attrs: { src: "/static/img/icons/apple-touch-icon-180x180.png" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34816a10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34816a10","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/check-out/CheckoutByCash.vue
// module id = 494
// module chunks = 1